import { useOrgConfigStateValue } from 'hooks/business/useOrgConfig';
import { isString } from 'lodash-es';
import { useCallback } from 'react';

export const isBase64 = (src: string) => /^data:/.test(src);

export const isShopeePic = (src: string) => {
  return src ? !isBase64(src) && /^.+(\.shopee\.|\.img\.susercontent\.com).+/.test(src) : false;
};

export const isLazadaPic = (src: string) => {
  return src ? !isBase64(src) && /^.+\.slatic\.net\/.+/.test(src) : false;
};

export const lazadaPicCompress = (src: string, size?: number | `${number}x${number}`) => {
  if (!isLazadaPic(src)) {
    return src;
  }
  const url = new URL(src);
  if (size) {
    const targetSize = typeof size === 'string' ? size : `_${size}x${size}`;
    url.pathname = url.pathname.replace(/$/, targetSize);
  }
  url.pathname = url.pathname.replace(/$/, '.webp');
  url.host = 'img-ovs.alicdn.com';
  return url.href;
};

const http2https = (url?: string) => {
  if (url && isString(url) && url.startsWith('http://')) {
    return url.replace('http://', 'https://');
  }
  return url;
};

export const getImageThumb = (url: string, platform?: General.CaselessPlatformTunnel) => {
  if (platform?.toUpperCase() === 'SHOPEE' && !url?.endsWith('_tn')) {
    const processedUrl = http2https(url);
    return `${processedUrl}_tn`;
  }

  if (platform?.toUpperCase() === 'LAZADA' && url) {
    return lazadaPicCompress(url, 128);
  }

  const transformedUrl = http2https(url);

  return transformedUrl || url;
};

export const getTiktokProxyImageSrc = (imageSrc: string) =>
  `https://prq-api.leyanbot.com/oversea_locust_proxy/image_proxy?image_url=${encodeURIComponent(
    imageSrc,
  )}`;

export const useGetAvatarSrc = () => {
  const { tiktokImageProxyOriginList } = useOrgConfigStateValue();

  return useCallback(
    (buyerAvatar: string, platform: General.PlatformUpperCaseTunnel) => {
      if (buyerAvatar.startsWith('https://graph.facebook.com')) {
        return '';
      }
      return tiktokImageProxyOriginList?.some((origin) => buyerAvatar.includes(origin))
        ? getTiktokProxyImageSrc(buyerAvatar)
        : getImageThumb(buyerAvatar, platform);
    },
    [tiktokImageProxyOriginList],
  );
};
